export const parseImage = (image) => {
  return {
    src: image?.fields?.file?.url?.replace('//', 'https://'),
    width: image?.fields?.file?.details?.image?.width,
    height: image?.fields?.file?.details?.image?.height,
    alt: image?.fields?.title,
  };
};
